/** Money is held in micro-dollars: 1,000,000 = $1.00, so a price like $0.025 needs no rounding. */
export const MICROS_PER_CENT = 10_000
export const MICROS_PER_DOLLAR = 1_000_000

/** Prepaid credit rules (docs/billing.spec.md). Inputs are whole cents; balances and prices come out in micros. */
export const BILLING = {
  /** The price at launch, $0.05 per live envelope. The ledger migration seeds it; later prices come from the price schedule. */
  initialPriceMicros: 50_000,
  /** One purchase (top-up, auto-reload, wallet): $20.00 to $1,000.00 before tax. */
  purchaseMinCents: 2_000,
  purchaseMaxCents: 100_000,
  purchasePresetCents: [2_000, 5_000, 10_000],
  refundFeePercent: 5,
  defaultLowBalanceThresholdMicros: 5_000_000,
  /** The low-balance threshold and the auto-reload trigger: up to $1,000.00. */
  thresholdMaxCents: 100_000,
  autoReloadTriggerMinCents: 1,
  autoReloadMonthlyCapMaxCents: 10_000_000,
  /** One staff grant: up to $1,000.00. */
  grantMaxCents: 100_000,
  /** A price per live envelope: up to $10.00. */
  priceMaxMicros: 10_000_000,
  priceIncreaseNoticeDays: 30,
  historyRetentionYears: 7,
  historyPageSize: 50,
  /** How long a Stripe Checkout page stays open: Stripe's minimum of 30 minutes, plus a minute for clock skew. */
  checkoutLifetimeMs: 31 * 60_000,
} as const
